<h2 class="header-medium px-medium mt-medium">{{ title }}</h2>
@if (description && description.length > 0) {
    <p class="px-medium mt-medium body-copy">{{ description }}</p>
}
@if (messages?.pre) {
    <div class="flex flex-col px-medium mt-medium">
        <div class="w-full body-copy">{{ messages?.pre }}</div>
    </div>
}
<mat-card appearance="outlined" class="p-medium mt-medium">
    <ng-content></ng-content>
</mat-card>

@if (messages?.post) {
    <div class="flex flex-col px-medium mt-medium" [ngClass]="{ isXS: (isXS$ | async) }">
        <div class="w-full body-copy">
            {{ messages?.post }}
        </div>
    </div>
}
